import SEO from '../pages/SEO';
import React from "react";
import { Card, CardContent } from "../components/ui/card";
import { CheckCircle2 } from "lucide-react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export default function ShoulderKneeHipPage() {
  const conditions = [
    {
      joint: "Shoulder",
      issues: [
        "Rotator cuff tears",
        "Frozen shoulder",
        "Shoulder impingement",
        "Arthritis",
        "Instability and dislocations",
      ],
    },
    {
      joint: "Knee",
      issues: [
        "Osteoarthritis",
        "Meniscus tears",
        "Ligament injuries",
        "Patellofemoral pain",
        "Cartilage damage",
      ],
    },
    {
      joint: "Hip",
      issues: [
        "Hip arthritis",
        "Labral tears",
        "Bursitis",
        "Tendonitis",
        "Femoroacetabular impingement",
      ],
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Shoulder, Knee & Hip Specialist in Hyderabad"
        description="Consult Dr. Sujit Kumar in Hyderabad for shoulder, knee and hip pain, injuries, arthritis and evidence-based surgical or non-surgical treatment options."
        keywords="shoulder specialist Hyderabad, knee doctor Hyderabad, hip specialist Hyderabad, joint pain doctor, orthopedic surgeon"
        canonical="https://www.drsujitkumar.com/treatments/shoulder-knee-hip"
        robots="index, follow"
      />
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-[family-name:var(--font-playfair)]">
            Shoulder, Knee & Hip Care
          </h1>
          <p className="text-lg text-primary-foreground/90 leading-relaxed max-w-2xl mx-auto">
            Specialized treatment for joint pain and mobility issues.
          </p>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 items-start">
            <div>
              <h2 className="text-3xl font-bold mb-6 font-[family-name:var(--font-playfair)]">
                Focused Joint Care Clinics
              </h2>
              <div className="prose prose-lg max-w-none space-y-4">
                <p className="text-foreground leading-relaxed">
                  Our specialized clinics provide comprehensive evaluation and
                  treatment for shoulder, knee, and hip conditions. We offer a
                  full spectrum of care from conservative management to surgical
                  intervention.
                </p>
                <p className="text-foreground leading-relaxed">
                  Treatment options include pain evaluation, physiotherapy
                  protocols, injections when appropriate, and surgical options
                  when conservative care fails. Our goal is to restore function
                  and improve your quality of life.
                </p>
              </div>
            </div>

            <div className="relative h-[400px] rounded-lg overflow-hidden shadow-xl">
              <img
                src="/shoulder-knee-hip-joint-pain-treatment-orthopedic.jpg"
                alt="Joint care treatment"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Conditions Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center mb-12 font-[family-name:var(--font-playfair)]">
            Conditions We Treat
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {conditions.map((condition) => (
              <Card key={condition.joint}>
                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold mb-4">
                    {condition.joint}
                  </h3>
                  <ul className="space-y-2">
                    {condition.issues.map((issue, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <CheckCircle2 className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-muted-foreground text-sm">
                          {issue}
                        </span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
